import React from "react";
import styles from "./lists.module.scss";
import { GrantedPermission } from "@/types/modular-permissions.types";
import type { UseAccountReturnType, Config } from "wagmi";
import PermissionsCard from "@/features/mod-perms/components/cards/permissions-card/permissions-card";

type Props = {
  accountStatus: UseAccountReturnType<Config>;
  permissions: GrantedPermission[];
  isLoading: boolean;
};

const DelegationList = ({ permissions, isLoading, accountStatus }: Props) => {
  if (permissions.length && !isLoading && accountStatus.isConnected)
    return (
      <div className={styles.delegateList}>
        {permissions.map((delegate) => (
          <PermissionsCard
            key={delegate.delegate + "-granted"}
            delegate={delegate}
          />
        ))}
      </div>
    );
};

export default DelegationList;
